
export function generateStyles(theme) {
  const styles = [];

  if (theme) {
    // Styles for main title
    if (theme.title) {
      if (theme.title.bg) {
        styles.push(`
          .theme-custom .SideNav h1 {
            background-color: ${theme.title.bg};
          }
        `);
      }
      if (theme.title.color) {
        styles.push(`
          .theme-custom .SideNav h1 {
            color: ${theme.title.color};
          }
        `);
      }
    }

    // Main Menu
    if (theme.mainMenu) {
      if (theme.mainMenu.bg1) {
        styles.push(`
          .theme-custom .SideNav .bg-main-menu {
            background-color: ${theme.mainMenu.bg1};
          }
        `);
      }
      if (theme.mainMenu.titles) {
        styles.push(`
          .theme-custom .SideNav ul li {
            color: ${theme.mainMenu.titles};
          }
        `);
      }
      if (theme.mainMenu.color) {
        styles.push(`
          .theme-custom .SideNav ul li a {
            color: ${theme.mainMenu.color};
          }
        `);
      }
      if (theme.mainMenu.selected) {
        styles.push(`
          .theme-custom .SideNav ul li a.SideNav__MenuItem__active {
            color: ${theme.mainMenu.selected};
          }
        `);
      }
      if (theme.mainMenu.border) {
        styles.push(`
          .theme-custom .SideNav ul li .SideNav__MenuItem__selected  {
            border-color: ${theme.mainMenu.border};
          }
        `);
      }
    }

    // Main top toolbar
    if (theme.mainToolbar) {
      if (theme.mainToolbar.bg) {
        styles.push(`
          .theme-custom .TopNav {
            background-color: ${theme.mainToolbar.bg};
          }
        `);
      }
      if (theme.mainToolbar.color) {
        styles.push(`
          .theme-custom .TopNav button {
            color: ${theme.mainToolbar.color};
          }
        `);
      }
      if (theme.mainToolbar.iconColor) {
        styles.push(`
          .theme-custom .TopNav button svg {
            color: ${theme.mainToolbar.iconColor};
          }
        `);
      }
    }

    // The player
    if (theme.player) {
      if (theme.player.bg) {
        styles.push(`
          .theme-custom .Player {
            background-color: ${theme.player.bg};
          }
        `);
      }
      if (theme.player.color) {
        styles.push(`
          .theme-custom .Player a,
          .theme-custom .Player button,
          .theme-custom .Player h4,
          .theme-custom .Player .Player_progress .text-secondary {
            color: ${theme.player.color};
          }
        `);
      }
      if (theme.player.buttonsOverBg) {
        styles.push(`
          .theme-custom .Player button:hover {
            background-color: ${theme.player.buttonsOverBg};
          }
        `);
      }
      if (theme.player.progress) {
        styles.push(`
          .theme-custom .Player .Player_progress .bg-primary {
            background-color: ${theme.player.progress};
          }
        `);
      }
      if (theme.player.loaded) {
        styles.push(`
          .theme-custom .Player .Player_progress .bg-neutral {
            background-color: ${theme.player.loaded};
          }
        `);
      }
      if (theme.player.total) {
        styles.push(`
          .theme-custom .Player .Player_progress .bg-thumbnail {
            background-color: ${theme.player.total};
          }
        `);
      }
    }

    // Common areas
    if (theme.common) {
      if (theme.common.mainBg) {
        styles.push(`
          body.theme-custom  {
            background-color: ${theme.common.mainBg};
          }
        `);
      }
      if (theme.common.containersBg) {
        styles.push(`
          .theme-custom .Panel,
          .theme-custom .Banner {
            background-color: ${theme.common.containersBg};
          }
        `);
      }
      if (theme.common.containersBorderColor) {
        styles.push(`
          .theme-custom .Panel,
          .theme-custom .Banner {
            border-color: ${theme.common.containersBorderColor};
          }
        `);
      }
      if (theme.common.color) {
        styles.push(`
          .theme-custom .Layout_Main__main p,
          .theme-custom .Layout_Main__main h1,
          .theme-custom .Layout_Main__main h2,
          .theme-custom .Layout_Main__main h3,
          .theme-custom .Layout_Main__main h4,
          .theme-custom h1.text-default,
          .theme-custom h2.text-default,
          .theme-custom h3.text-default,
          .theme-custom h4.text-default,
          .theme-custom p.text-default,
          .theme-custom span.text-default,
          .theme-custom strong.text-default {
            color: ${theme.common.color};
          }
        `);
      }
      if (theme.common.secondaryColor) {
        styles.push(`
          .theme-custom p.text-secondary,
          .theme-custom span.text-secondary,
          .theme-custom small.text-secondary,
          .theme-custom strong.text-secondary,
          .theme-custom em.text-secondary,
          .theme-custom i.text-secondary,
          .theme-custom li.text-secondary,
          .theme-custom h1.text-secondary,
          .theme-custom h2.text-secondary,
          .theme-custom h3.text-secondary,
          .theme-custom h4.text-secondary {
            color: ${theme.common.secondaryColor};
          }
        `);
      }
      if (theme.common.tertiaryColor) {
        styles.push(`
          .theme-custom .Layout_Main__main p.text-tertiary,
          .theme-custom .Layout_Main__main span.text-tertiary,
          .theme-custom .Layout_Main__main small.text-tertiary,
          .theme-custom .Layout_Main__main strong.text-tertiary,
          .theme-custom .Layout_Main__main em.text-tertiary,
          .theme-custom .Layout_Main__main i.text-tertiary,
          .theme-custom .Layout_Main__main li.text-tertiary,
          .theme-custom .Layout_Main__main h1.text-tertiary,
          .theme-custom .Layout_Main__main h2.text-tertiary,
          .theme-custom .Layout_Main__main h3.text-tertiary,
          .theme-custom .Layout_Main__main h4.text-tertiary {
            color: ${theme.common.tertiaryColor};
          }
        `);
      }
      if (theme.common.linkColor) {
        styles.push(`
          .theme-custom .Layout_Main__main a {
            color: ${theme.common.linkColor};
          }
        `);
      }
      if (theme.common.linkHoverColor) {
        styles.push(`
          .theme-custom .Layout_Main__main a:hover {
            color: ${theme.common.linkHoverColor};
          }
        `);
      }
    }

    // Form components
    if (theme.forms) {
      if (theme.forms.bg) {
        styles.push(`
          .theme-custom .Texfield .Texfield_input,
          .theme-custom .SelectField .SelectField_input,
          .theme-custom .Dropdown_list .bg-dropdown,
          .theme-custom .Toast,
          .theme-custom .Autocomplete .list {
            background-color: ${theme.forms.bg};
          }
        `);
      }
      if (theme.forms.bgOver) {
        styles.push(`
          .theme-custom .Layout_Main__main .bg-list-active,
          .theme-custom .Layout_Main__main .hover\\:bg-list-active:hover,
          .theme-custom .Dropdown_list .bg-dropdown button:hover {
            background-color: ${theme.forms.bgOver};
          }
        `);
      }
      if (theme.forms.border) {
        styles.push(`
          .theme-custom .Texfield .Texfield_input,
          .theme-custom .SelectField .SelectField_input {
            border: 1px solid ${theme.forms.border};
          }
        `);
        styles.push(`
          .theme-custom .ColorField button {
            border-color: ${theme.forms.border};
          }
        `);
        styles.push(`
          .theme-custom .SelectField .SelectField_input svg {
            color: ${theme.forms.border};
          }
        `);
      }
      if (theme.forms.color) {
        styles.push(`
          .theme-custom .SelectField span,
          .theme-custom .SelectField button,
          .theme-custom .Texfield .Texfield_input,
          .theme-custom .Texfield span {
            color: ${theme.forms.color};
          }
        `);
      }
      if (theme.forms.placeholderColor) {
        styles.push(`
          ::placeholder {
            color: ${theme.forms.placeholderColor};
          }
        `);
      }
    }

    // Buttons components
    if (theme.buttons) {
      if (theme.buttons.primaryBg) {
        styles.push(`
          .theme-custom .ActionBar_button.bg-primary,
          .theme-custom .Button.primary {
            background-color: ${theme.buttons.primaryBg};
          }
        `);
      }
      if (theme.buttons.primaryOverBg) {
        styles.push(`
          .theme-custom .Button.primary:hover,
          .theme-custom .ActionBar_button.bg-primary:hover {
            background-color: ${theme.buttons.primaryOverBg};
          }
        `);
      }
      if (theme.buttons.primaryColor) {
        styles.push(`
          .theme-custom .Button.primary,
          .theme-custom a.ActionBar_button.bg-primary {
            color: ${theme.buttons.primaryColor};
          }
        `);
      }
      if (theme.buttons.primaryBorderColor) {
        styles.push(`
          .theme-custom .Button.primary,
          .theme-custom a.ActionBar_button.bg-primary {
            border-width: 2px;
            border-color: ${theme.buttons.primaryBorderColor};
          }
        `);
      }
      if (theme.buttons.secondaryBg) {
        styles.push(`
          .theme-custom .Button.secondary,
          .theme-custom .ActionBar_button {
            background-color: ${theme.buttons.secondaryBg};
          }
        `);
      }
      if (theme.buttons.secondaryOverBg) {
        styles.push(`
          .theme-custom .Button.secondary:hover,
          .theme-custom .ActionBar_button:hover {
            background-color: ${theme.buttons.secondaryOverBg};
          }
        `);
      }
      if (theme.buttons.secondaryColor) {
        styles.push(`
          .theme-custom .Button.secondary,
          .theme-custom .ActionBar_button.text-secondary {
            color: ${theme.buttons.secondaryColor};
          }
        `);
      }
      if (theme.buttons.secondaryBorderColor) {
        styles.push(`
          .theme-custom .Button.secondary,
          .theme-custom .ActionBar_button {
            border-width: 2px;
            border-color: ${theme.buttons.secondaryBorderColor};
          }
        `);
      }
      if (theme.buttons.tertiaryBg) {
        styles.push(`
          .theme-custom .Button.tertiary {
            background-color: ${theme.buttons.tertiaryBg};
          }
        `);
      }
      if (theme.buttons.tertiaryOverBg) {
        styles.push(`
          .theme-custom .Button.tertiary:hover {
            background-color: ${theme.buttons.tertiaryOverBg};
          }
        `);
      }
      if (theme.buttons.tertiaryColor) {
        styles.push(`
          .theme-custom .Button.tertiary {
            color: ${theme.buttons.tertiaryColor};
          }
        `);
      }
      if (theme.buttons.tertiaryBorderColor) {
        styles.push(`
          .theme-custom .Button.tertiary {
            border-width: 2px;
            border-color: ${theme.buttons.tertiaryBorderColor};
          }
        `);
      }
    }

    // Buttons components
    if (theme.tags) {
      if (theme.tags.bg) {
        styles.push(`
          .theme-custom .Tag.Button {
            background-color: ${theme.tags.bg};
          }
        `);
      }
      if (theme.tags.bgOver) {
        styles.push(`
          .theme-custom .Tag.Button:hover {
            background-color: ${theme.tags.bgOver};
          }
        `);
      }
      if (theme.tags.color) {
        styles.push(`
          .theme-custom .Tag.Button {
            color: ${theme.tags.color};
          }
        `);
      }
      if (theme.tags.colorOver) {
        styles.push(`
          .theme-custom .Tag.Button:hover {
            color: ${theme.tags.colorOver};
          }
        `);
      }

      if (theme.custom) {
        styles.push(theme.custom);
      }
    }
  }
  return styles.join(' ');
}